<div class="modal-container">
  <h1 mat-dialog-title>O que é uma emergência?</h1>
  <div mat-dialog-content>
    <p>
      Atualmente, estão sendo consideradas como emergências os casos relatados
      imediatamente após a ocorrência, limitado apenas às vítimas do gênero
      feminino que podem ser atendidas pelas delegacias parceiras da Super NINA.
    </p>
  </div>
  <button mat-button mat-dialog-close>Ok</button>
</div>
